<template lang="html">
    <div id="airports-menu">
        <md-tabs :md-active-tab="activeTab">
            <md-tab id="tab-airportprices"    v-bind:to="{ name: 'AirportPrices'}"         md-label="Список"></md-tab>
            <md-tab id="tab-airportluwprices" v-bind:to="{ name: 'AirportLuwPrices'}"      md-label="Список ПРР"></md-tab>
            <md-tab id="tab-settings"         v-bind:to="{ name: 'AirportPricesSettings'}" md-label="Настройки"></md-tab>
        </md-tabs>
    </div>
</template>
<script>
    export default {
        name: 'airports-menu',
        data() {
            return {
                activeTab: null
            }
        },
        watch: {
            '$route'() {
                this.activeTab = 'tab-' + this.$route.meta.tab;
            }
        },
        created() {
            this.activeTab = 'tab-' + this.$route.meta.tab;
        }
    }
</script>



// WEBPACK FOOTER //
// AirportsMenu.vue?b6263508